<template>
  <main>
    <b-row>
      <b-col lg="4" md="6" sm="12">
        <statistic-card-horizontal @onClick="$router.push('/penjualan')" icon="ShoppingCartIcon" color="primary" :statistic="cardPenjualan" statistic-title="Total Penjualan" />
      </b-col>
      <b-col lg="4" md="6" sm="12">
        <statistic-card-horizontal @onClick="$router.push('/collection')" icon="CreditCardIcon" color="success" :statistic="cardCollection" statistic-title="Collection" />
      </b-col>
      <b-col lg="4" md="6" sm="12">
        <statistic-card-horizontal @onClick="$router.push('/rank-sales')" icon="BarChart2Icon" color="warning" :statistic="cardSales" statistic-title="Rank Sales" />
      </b-col>
      <b-col cols="12">
        <sales-graphic />
      </b-col>
      <br />
      <br />
      <b-col cols="12">
        <profit-and-loss-graphic />
      </b-col>
      <br />
      <br />
    </b-row>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import ProfitAndLossGraphic from './_profit_and_loss.vue'
import SalesGraphic from './_penjualan.vue'
export default {
  data() {
    return {
      dataPenjualan: {},
      card: {},
      dataLabaRugi: {}
    };
  },
  components: {
    ProfitAndLossGraphic,
    SalesGraphic,
    StatisticCardHorizontal,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardPenjualan() {
      return "Rp " + this.formatRupiah(this.card.penjualan);
    },
    cardSales() {
      return this.card.sales + " Orang";
    },
    cardCollection() {
      return "Rp " + this.formatRupiah(this.card.collection);
    },
    cardKeuntungan() {
      return "Rp " + this.formatRupiah(this.card.keuntungan);
    },
  },
  methods: {
    getGrafikLabaRugi() {
      let params = {
        tgl_awal: "2022-01-01",
        tgl_akhir: "2022-12-31",
      };

      this.$store
        .dispatch("dashboard/getGrafikLabaRugi", params)
        .then(() => {
          this.dataLabaRugi = JSON.parse(JSON.stringify(this.$store.state.dashboard.dataLaba));
          this.dataChartBar2.xAxis.data = this.dataLabaRugi.label;
          this.dataChartBar2.series[0].data = this.dataLabaRugi.data;
        })
        .catch((e) => console.error(e));
    },
    postCardInfo() {
      let payload = {
        show: {
          penjualan: true,
          sales: true,
          karyawan: false,
          collection: true,
          assetTotal: false,
          assetNilai: false,
          barangMobilNilai: false,
          keuntungan: true,
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },

  mounted() {
    this.postCardInfo();
  },
};
</script>
